import { SecurityTypeCode } from "@/lib/interfaces and Enums/ENUMSecurityTypeCode";
import { create } from "zustand";

export interface IAllocations {
  complianceStatus: string;
  dV01: number;
  id: number;
  notionalLeg1: number;
  notionalLeg2: number;
  portfolio: string;
  direction?: string; // taken from IImportJSONBlock direction
  securityName?: string;
  setDT?: Date;
  risk?: number;
  creditSpreadRisk: number;
}

export interface IImportJsonBlocks {
  id: number;
  // Present at runtime (read in RiskDV01CellRenderer). Creation blocks identify their structure
  // via securityType — used to detect swap blocks dragged into the Swap Curve widget.
  securityType?: SecurityTypeCode;
  direction: string;
  notionalLeg1: number;
  notionalLeg2: number | null;
  openClose: string;
  securityName: string;
  isin?: string;
  effectiveDate: Date;
  extStructureId: string;
  dateCreated: Date;
  dV01: number;
  allocations: IAllocations[];
  creditSpreadRisk: number;
}

interface IimportBlocksAndAllocations {
  allBlocks: IImportJsonBlocks[];
  blockIdsToFlash: number[];
  // eslint-disable-next-line no-unused-vars
  setImportBlocks: (incomingData: IImportJsonBlocks[]) => void;
  // eslint-disable-next-line no-unused-vars
  updateBlockIdsToFlash: (ids: number[]) => void;
}

const importBlocksAndAllocationsStore = create<IimportBlocksAndAllocations>(
  (set) => ({
    allBlocks: [],
    blockIdsToFlash: [],
    setImportBlocks: (incomingData) => set({ allBlocks: incomingData }),
    updateBlockIdsToFlash: (ids) => set({ blockIdsToFlash: ids }),
  }),
);

export default importBlocksAndAllocationsStore;
